import React from "react";
import ic_logout from "../img/ic_logout.png";
import { useNavigate } from "react-router-dom";
import ic_close from "../img/ic_close_search_box.png";

function SideDrawer(props) {
    
    const {showHideSideDrawer} = props;

    const navigate = useNavigate();

    const logOut =()=>{
        localStorage.setItem("cwheels_user_isAuthenticated", false);
        navigate('/login');
    }

    return (

        <div className="SideDrawer-root-container">

            <img onClick={showHideSideDrawer} className="SideDrawer-close-image" src={ic_close}/>

            <p className="mt-3" onClick={()=>logOut()}><img src={ic_logout}/> Logout</p>
        </div>
    )
}

export default SideDrawer;